import React, { useState, useEffect } from "react";
import logo from "../../resource/7.png";
import Swal from "sweetalert2";
import axios from "axios";
import apiClient from "@/api/client";

const FeaturePlanRequest = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    postal_code: "",
    mobile_number: "",
    wt_number: "",
    email: "",
    contribute: "",
    inquire: "",
    ip_address: "",
  });

  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({}); // Error state

  // Fetch IP address on component mount
  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setFormData((prevFormData) => ({
          ...prevFormData,
          ip_address: response.data.ip, // Set the IP address
        }));
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};

    // Validate First Name
    if (!formData.firstName) newErrors.firstName = "First Name is required";

    // Validate Last Name
    if (!formData.lastName) newErrors.lastName = "Last Name is required";

    // Validate Address
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.postal_code) newErrors.postal_code = "Postal Code is required";
    else if (!/^\d{5}$/.test(formData.postal_code)) newErrors.postal_code = "Postal Code must be 5 digits";

    if (!formData.mobile_number) newErrors.mobile_number = "Mobile Number is required";
    if (!formData.wt_number) newErrors.wt_number = "WhatsApp Number is required";
    if (!formData.email) newErrors.email = "Email is required";

    // Validate Email (if provided)
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format";

    // Validate Mobile Number (if provided)
    if (formData.mobile_number && !/^\d{10}$/.test(formData.mobile_number))
      newErrors.mobile_number = "Mobile Number should be 10 digits";

    // Validate WhatsApp Number (if provided)
    if (formData.wt_number && !/^\d{10}$/.test(formData.wt_number))
      newErrors.wt_number = "WhatsApp Number should be 10 digits";

    // Validate Contribution
    if (!formData.contribute) newErrors.contribute = "Contribution details are required";
    if (!formData.inquire) newErrors.inquire = "Inquiry details are required";

    setErrors(newErrors); // Set errors
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the form for errors.",
      });
      return; // Stop execution if validation fails
    }

    setLoading(true); // Set loading state

    try {
      // Submit form data to API
      const response = await apiClient.post('/future_plans_request_form-request',
          formData
      );

      console.log("Form submitted successfully:", response.data);

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Form submitted successfully!",
      });

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        postal_code: "",
        mobile_number: "",
        wt_number: "",
        email: "",
        contribute: "",
        inquire: "",
        ip_address: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);

      // Handle API errors
      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please check your internet connection.";
      } else {
        errorMessage = "An unexpected error occurred. Please try again later.";
      }

      // Show error message
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
      <div className="form-page dark-gold ">
        <form onSubmit={handleSubmit}>
          <div className="form-title">
            <img src={logo} alt="" width={200} />
            <div className="details">
              <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
              <h2 className="h4">Future Plans Request Form</h2>
            </div>
          </div>

          <p className="font-p mt-5">
            Welcome to Bhaddheka Vihari Monastery Future Plans
          </p>
          <p className="font-p mt-4">Use the following form to fill your details.</p>

          {/* Full Name */}
          <p className="font-p mt-5">Full Name*</p>
          <div className="form-box mt-4">
            <div className="form-item">
              <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  disabled={loading}
              />
              <label htmlFor="firstName">First Name</label>
              {errors.firstName && <span className="error">{errors.firstName}</span>}
            </div>
            <div className="form-item">
              <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
              />
              <label htmlFor="lastName">Last Name</label>
              {errors.lastName && <span className="error">{errors.lastName}</span>}
            </div>
          </div>

          {/* Address */}
          <div className="form-box1 mt-4">
            <div className="form-item">
              <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
              />
              <label htmlFor="address">Address*</label>
              {errors.address && <span className="error">{errors.address}</span>}
            </div>
          </div>

          {/* City */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
              />
              <label htmlFor="city">City</label>
              {errors.city && <span className="error">{errors.city}</span>}
            </div>
          </div>

          {/* Postal Code */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="postal_code"
                  name="postal_code"
                  value={formData.postal_code}
                  onChange={handleInputChange}
              />
              <label htmlFor="postal_code">Postal Code</label>
              {errors.postal_code && <span className="error">{errors.postal_code}</span>}
            </div>
          </div>

          {/* Mobile Number and WhatsApp Number */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="mobile_number"
                  name="mobile_number"
                  value={formData.mobile_number}
                  onChange={handleInputChange}
              />
              <label htmlFor="mobile_number">Mobile Number</label>
              {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
            </div>
            <div className="form-item">
              <input
                  type="text"
                  id="wt_number"
                  name="wt_number"
                  value={formData.wt_number}
                  onChange={handleInputChange}
              />
              <label htmlFor="wt_number">WhatsApp Number</label>
              {errors.wt_number && <span className="error">{errors.wt_number}</span>}
            </div>
          </div>

          {/* Email Address */}
          <div className="form-box1 mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
              />
              <label htmlFor="email">Email Address</label>
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
          </div>

          <p className="font-p mt-5">
            Please indicate the type of project you intend to support or materials you would like to supply for the Monastery.
          </p>

          <div className=" mt-5">
            <div className="form-item">
          <textarea
              type="text"
              id="contribute"
              name="contribute"
              value={formData.contribute}
              onChange={handleInputChange}
              rows="6"
          />
              <label htmlFor="contribute"></label>
              {errors.contribute && <span className="error">{errors.contribute}</span>}
            </div>
          </div>

          <p className="font-p mt-5">
            Please write any specific questions or queries you would like to clarify on future plans at the Monastery.
          </p>

          <div className=" mt-5">
            <div className="form-item">
          <textarea
              type="text"
              id="inquire"
              name="inquire"
              value={formData.inquire}
              onChange={handleInputChange}
              rows="6"
          />
              <label htmlFor="inquire"></label>
              {errors.inquire && <span className="error">{errors.inquire}</span>}
            </div>
          </div>

          {/* Submit Button */}
          <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>

          <p className="font-p mt-5">
            We look forward to facilitating your request and are grateful for choosing Bhaddheka Vihari Monastery, an enriching space for practicing mindfulness meditation.
          </p>
        </form>
      </div>
  );
};

export default FeaturePlanRequest;